export const PageHeader = ({ eyebrow, title, children, testid }) => (
  <div className="flex items-end justify-between gap-6 mb-8 rise" data-testid={testid}>
    <div>
      <p className="label-xs text-brand">{eyebrow}</p>
      <h1 className="font-mono text-4xl tracking-tighter font-extrabold mt-2">{title}</h1>
    </div>
    <div className="flex items-center gap-3">{children}</div>
  </div>
);

export const Panel = ({ title, action, children, className = "", testid }) => (
  <section className={`panel ${className}`} data-testid={testid}>
    {title && (
      <div className="flex items-center justify-between px-5 py-3 border-b border-line">
        <h3 className="label-xs">{title}</h3>
        {action}
      </div>
    )}
    <div className="p-5">{children}</div>
  </section>
);

export const NeonButton = ({ children, className = "", variant = "primary", ...props }) => {
  const styles = {
    primary: "bg-brand text-black hover:brightness-110 hover:shadow-[0_0_24px_var(--brand)]",
    ghost: "border border-[#24302E] text-white hover:border-brand hover:text-brand",
    danger: "border border-[#F87171]/50 text-[#F87171] hover:bg-[#F87171]/10",
  };
  return (
    <button
      className={`inline-flex items-center gap-2 whitespace-nowrap px-4 py-2 rounded-sm font-mono text-xs uppercase tracking-[0.15em] font-bold transition-[box-shadow,filter,border-color,color,background-color,transform] duration-150 active:scale-[0.97] disabled:opacity-40 disabled:pointer-events-none ${styles[variant]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};
